export function getEventEditChannel() {
    if (!window.eventEditChannel) {
            window.eventEditChannel = new BroadcastChannel('event-edit');
    }

    return window.eventEditChannel;
}



// WEBPACK FOOTER //
// ./src/utils/eventEditChannel.js